const normalizeVoiceName = (value) =>
  String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();

const PREFERRED_FRENCH_VOICE_NAMES = [
  "amelie",
  "audrey",
  "aurelie",
  "marie",
  "juliette",
  "denise",
  "hortense",
  "lea",
  "celine",
  "flo",
];

export const selectRhodeVoice = (voices, savedName = "") => {
  const available = Array.isArray(voices) ? voices.filter(Boolean) : [];
  if (!available.length) return null;

  const normalizedSavedName = normalizeVoiceName(savedName);
  if (normalizedSavedName) {
    const saved = available.find(
      (voice) => normalizeVoiceName(voice?.name) === normalizedSavedName,
    );
    if (saved) return saved;
  }

  const frenchVoices = available.filter((voice) =>
    String(voice?.lang || "")
      .trim()
      .toLowerCase()
      .startsWith("fr"),
  );
  if (!frenchVoices.length) return null;

  for (const preferredName of PREFERRED_FRENCH_VOICE_NAMES) {
    const preferred = frenchVoices.find((voice) =>
      normalizeVoiceName(voice?.name).includes(preferredName),
    );
    if (preferred) return preferred;
  }

  return frenchVoices[0] || null;
};

